(() => {
  const labelIframe = (frame) => {
    if (!frame || frame.getAttribute('title')) return;
    frame.setAttribute('title', 'Shopify notification');
  };

  const labelDialog = (dialog) => {
    if (!dialog || dialog.getAttribute('aria-label') || dialog.getAttribute('aria-labelledby')) return;
    const heading = dialog.querySelector('h1, h2, h3, [role="heading"]');
    if (heading && heading.textContent.trim()) {
      if (!heading.id) heading.id = 'shopify-injected-dialog-title-' + Math.random().toString(36).slice(2, 8);
      dialog.setAttribute('aria-labelledby', heading.id);
    } else {
      dialog.setAttribute('aria-label', 'Notification');
    }
  };

  // Build a unique accessible name so multiple scroll regions don't share one
  // landmark label (axe landmark-unique). Prefer the table caption or a nearby
  // heading; otherwise fall back to a numbered "Scrollable content".
  const usedScrollLabels = new Set();
  let scrollRegionSeq = 0;
  const uniqueScrollLabel = (el) => {
    const caption = el.querySelector('caption');
    let base = caption && caption.textContent.trim();
    let prev = el.previousElementSibling;
    while (prev && !base) {
      if (/^H[1-3]$/.test(prev.tagName) && prev.textContent.trim()) base = prev.textContent.trim();
      prev = prev.previousElementSibling;
    }
    if (!base) base = 'Scrollable content';
    let label = base;
    while (usedScrollLabels.has(label)) {
      scrollRegionSeq += 1;
      label = base + ' ' + scrollRegionSeq;
    }
    usedScrollLabels.add(label);
    return label;
  };

  const labelScrollRegion = (el) => {
    if (!el || el.getAttribute('tabindex') !== null) return;
    el.setAttribute('tabindex', '0');
    if (!el.getAttribute('role')) el.setAttribute('role', 'region');
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', uniqueScrollLabel(el));
  };

  const scan = (root) => {
    root.querySelectorAll('iframe#PBarNextFrame, iframe[src*="cdn.shopify"]').forEach(labelIframe);
    root.querySelectorAll('[role="dialog"]:not([aria-label]):not([aria-labelledby]), [role="alertdialog"]:not([aria-label]):not([aria-labelledby])').forEach(labelDialog);
    root.querySelectorAll('.mobile_scroll').forEach(labelScrollRegion);
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches) {
          if (node.matches('iframe')) labelIframe(node);
          else if (node.matches('[role="dialog"]') || node.matches('[role="alertdialog"]')) labelDialog(node);
          else if (node.matches('.mobile_scroll')) labelScrollRegion(node);
        }
        scan(node);
      }
    }
  });

  const start = () => {
    scan(document);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
